import { useGLTF } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { ObjectLoader } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import 'react';
import './common-DBpCdW70.esm.js';

const MagnifyingGlass = () => {
  const model = useGLTF(defineSrc('magnifying-glass.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('magnifying-glass-light.json'));
  const lens = model.scene.getObjectByName('Optimised_lens');
  useFrame(() => {
    lens.material.transparent = true;
    lens.material.opacity = 0.8;
    model.materials['Tapestry WebGL'].map.offset.x += -6e-4;
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      scale: 1.5,
      position: [0, -12, 0],
      object: model.scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { MagnifyingGlass as default };
//# sourceMappingURL=MagnifyingGlass-CirktDQ1.esm.js.map
